<template>
  <div class="w-full bg-primary-darkest">
    <div>
      <div class="testimonials text-center gap-4 px-3 py-5">
        <JoszakiHeading class="text-white" :level="1">
          {{ $t("landing.header.title") }}
        </JoszakiHeading>
        <JoszakiHeading
          v-if="$branding.hasFeature(FEATURES.PROFESSIONALS)"
          :level="2"
          class="text-white"
        >
          {{ $t("landing.header.subtitle1") }}
        </JoszakiHeading>
        <JoszakiHeading
          v-if="$branding.hasFeature(FEATURES.PROFESSIONALS)"
          :level="2"
          class="text-white"
        >
          {{ $t("landing.header.subtitle2") }}
        </JoszakiHeading>
      </div>
    </div>

    <div
      class="mx-auto max-w-3xl lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl px-3 py-14"
    >
      <OfferOrSearch
        v-if="
          $branding.hasFeature(FEATURES.JOB_MARKET) &&
          $branding.hasFeature(FEATURES.PROFESSIONALS)
        "
        @requestTender="
          onRequestTender({ source: 'quickOffer', description: $event })
        "
      />
      <div class="flex flex-col lg:flex-row gap-8 xl:py-14">
        <div
          v-if="$branding.hasFeature(FEATURES.REGISTRATION)"
          class="flex flex-col flex-1 items-center justify-center text-center text-white px-10"
        >
          <IconComponent
            pack="fas"
            class="text-white !text-4xl mb-4"
            size="is-large"
            icon="question-circle"
          />
          <p class="font-extrabold text-xl xl:text-2xl px-5">
            {{ $t("landing.areYouPro") }}
          </p>
          <p class="font-extrabold text-xl xl:text-2xl px-5">
            <NuxtLink
              class="text-primary hover:text-primary-light"
              :to="localePath({ name: 'registrationPage' })"
            >
              {{ $t("landing.register") }}
            </NuxtLink>
            {{ $t("landing.forFree") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OfferOrSearch from "~/components/mainpage/OfferOrSearch.vue";
import { useRequestTender } from "~/composables/requestTender";
import { FEATURES } from "~/config/pages/features.config";

export default {
  name: "DefaultIndexPage",
  components: {
    OfferOrSearch,
  },
  setup() {
    return {
      ...useRequestTender(),
      FEATURES,
    };
  },
  head() {
    const description = `${this.$t("landing.header.subtitle1")} ${this.$t(
      "landing.header.subtitle2"
    )}`;
    return {
      title: this.$t("landing.meta.metaTitle"),
      meta: [
        {
          hid: "og:title",
          property: "og:title",
          content: this.$t("landing.meta.metaTitle"),
        },
        {
          hid: "description",
          name: "description",
          content: description,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: description,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: `${this.$helpers.topDomain}`,
        },
      ],
      link: [
        {
          rel: "canonical",
          href: this.$helpers.topDomain,
        },
      ],
    };
  },
  mounted() {
    this.$trackers.pageview({
      pagename: this.$trackers.pageNames.HOME_PAGE,
    });
  },
  beforeDestroy() {
    this.$trackers.pageleave({
      pagename: this.$trackers.pageNames.HOME_PAGE,
    });
  },
  methods: {
    onRequestTender({ person, source, description } = {}) {
      this.requestTender({
        source,
        person,
        profession: this.profession,
        city: this.city,
        description,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@use "styles/_all-members" as global;

.testimonials {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(32, 42, 53, 1)),
    url("~@/assets/img/lading-hero-c.jpg") center center;
  background-size: cover;
  min-height: 30vh;
}
</style>
